import { event } from "./selection/on";
export default function () {
  var current = event,
      source;

  while (source = current.sourceEvent) current = source;

  return current;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_d3-selection@1.4.1@d3-selection/src/sourceEvent.js
// module id = 386
// module chunks = 0